import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';

const style = StyleSheet.create({
  wrap: {
    position: 'relative',
    display: 'flex',
  },
});


export const RelativeWrapper: React.FunctionComponent = ({ children }) => (
  <div className={css(style.wrap)}>
    {children}
  </div>
);

interface ConditionalVideoWrapProps {
  shouldWarp: boolean;
}

export const ConditionalRelativeWrap: React.FunctionComponent<ConditionalVideoWrapProps> = ({ shouldWarp, children }) => (shouldWarp ? <RelativeWrapper>{children}</RelativeWrapper> : <React.Fragment>{children}</React.Fragment>);
